import { render, staticRenderFns } from "./WheelLockControllerSettings.vue?vue&type=template&id=4b7baa39&"
import script from "./WheelLockControllerSettings.vue?vue&type=script&lang=js&"
export * from "./WheelLockControllerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports